import React from "react";
import { useRecoilValue } from "recoil";
import { PatientState } from "../../data/atoms";
import { GaitScore } from "../../models/reports";
import { convertDOBintoAge, getPatientAge } from "../../utils/sharedFunction";
import CustomBarGraph from "../Graphs/CustomBarGraph";
interface Props {
	score: GaitScore;
}
const Gait_Test: React.FC<Props> = ({ score }) => {
	const patientInfo = useRecoilValue(PatientState);
	const patientage = getPatientAge();
	debugger;
	let fallRiskOption = {
		graphName: "FallRisk",
		graphSVG: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="46"
				height="41"
				viewBox="0 0 46 41"
				fill="none">
				<g filter="url(#filter0_d_4480_20276)">
					<path
						d="M27.396 5.4308C28.1853 4.58942 28.1173 3.29077 27.2442 2.5302C26.371 1.76962 25.0233 1.83513 24.234 2.67652L16.975 10.4146C15.7448 11.7261 14.7877 13.2532 14.156 14.9129L13.7022 16.1051C12.5243 19.1996 9.79354 21.504 6.4549 22.2209L5.66811 22.3898C4.51927 22.6365 3.79548 23.7339 4.05148 24.841C4.30748 25.948 5.44633 26.6455 6.59517 26.3988L7.38196 26.2298C11.3265 25.3828 14.6752 22.9799 16.6599 19.6695L19.924 25.1174C20.6164 26.2729 21.9023 26.8923 23.1964 26.8243C23.2815 26.8438 23.3688 26.8585 23.4579 26.8681L27.8706 27.3411C28.5283 27.4116 29.1026 27.8022 29.3918 28.3757L32.1487 33.8434C32.6631 34.8635 33.9383 35.2887 34.997 34.793C36.0557 34.2974 36.4969 33.0685 35.9825 32.0484L33.2256 26.5807C32.2971 24.7393 30.4535 23.4853 28.3419 23.259L27.0672 23.1224L30.8423 18.7897C31.242 18.331 31.8466 18.086 32.4663 18.1318L39.7059 18.6662C40.8795 18.7528 41.9038 17.9062 41.9937 16.7754C42.0836 15.6445 41.2051 14.6575 40.0315 14.5709L32.7919 14.0365C30.8022 13.8896 28.8611 14.676 27.578 16.1486L24.7192 19.4297L20.6441 12.6283L27.396 5.4308Z"
						fill="black"
					/>
					<path
						d="M13.9985 7.78548C14.9513 9.37578 14.3859 11.4093 12.7355 12.3274C11.0852 13.2456 8.97492 12.7007 8.02209 11.1104C7.06927 9.52013 7.63471 7.48662 9.28506 6.56847C10.9354 5.65031 13.0457 6.19518 13.9985 7.78548Z"
						fill="black"
					/>
				</g>
				<defs>
					<filter
						id="filter0_d_4480_20276"
						x="0"
						y="0"
						width="46"
						height="41"
						filterUnits="userSpaceOnUse"
						colorInterpolationFilters="sRGB">
						<feFlood floodOpacity="0" result="BackgroundImageFix" />
						<feColorMatrix
							in="SourceAlpha"
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha"
						/>
						<feOffset dy="2" />
						<feGaussianBlur stdDeviation="2" />
						<feComposite in2="hardAlpha" operator="out" />
						<feColorMatrix
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
						/>
						<feBlend
							mode="normal"
							in2="BackgroundImageFix"
							result="effect1_dropShadow_4480_20276"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect1_dropShadow_4480_20276"
							result="shape"
						/>
					</filter>
				</defs>
			</svg>
		),
		graphTitle: "Fall Risk",
		graphTitleDesc: "",
		graphNormValue: 0,
		isgraphNorm: false,
		graphActualValue: [score?.fallRisk],
		graphActualValueLabel: [`${Math.round(score?.fallRisk)}%`],
		graphRange: [40, 51.2],
		graphRangeLabel: ["40%", "51.2%"],
		graphNoLines: [],
		minMax: true,
		graphUnit: "",
		graphAge: convertDOBintoAge(new Date(patientInfo?.dob)),
	};
	let gaitSpeedOption = {
		graphName: "GaitSpeed",
		graphSVG: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="50"
				height="41"
				viewBox="0 0 30 35"
				fill="none">
				<g filter="url(#filter0_d_4669_272)">
					<path
						d="M33.0479 16.898C33.0479 24.0917 27.2177 29.9219 20.024 29.9219C12.8303 29.9219 7 24.0917 7 16.898C7 9.70428 12.8303 3.87402 20.024 3.87402C27.2177 3.87402 33.0479 9.70428 33.0479 16.898ZM21.6519 8.75801C21.6519 7.85752 20.9244 7.13001 20.024 7.13001C19.1235 7.13001 18.396 7.85752 18.396 8.75801C18.396 9.65849 19.1235 10.386 20.024 10.386C20.9244 10.386 21.6519 9.65849 21.6519 8.75801ZM20.024 25.0379C21.8198 25.0379 23.2799 23.5778 23.2799 21.782C23.2799 20.8967 22.9289 20.098 22.3591 19.5129L25.6202 12.1005C25.8898 11.4849 25.61 10.7625 24.9944 10.4928C24.3788 10.2232 23.6564 10.503 23.3868 11.1186L20.1206 18.526C20.0901 18.526 20.0545 18.526 20.024 18.526C18.2281 18.526 16.768 19.9861 16.768 21.782C16.768 23.5778 18.2281 25.0379 20.024 25.0379ZM15.954 11.2C15.954 10.2995 15.2265 9.572 14.326 9.572C13.4255 9.572 12.698 10.2995 12.698 11.2C12.698 12.1005 13.4255 12.828 14.326 12.828C15.2265 12.828 15.954 12.1005 15.954 11.2ZM11.884 18.526C12.7845 18.526 13.512 17.7985 13.512 16.898C13.512 15.9975 12.7845 15.27 11.884 15.27C10.9835 15.27 10.256 15.9975 10.256 16.898C10.256 17.7985 10.9835 18.526 11.884 18.526ZM29.7919 16.898C29.7919 15.9975 29.0644 15.27 28.1639 15.27C27.2634 15.27 26.5359 15.9975 26.5359 16.898C26.5359 17.7985 27.2634 18.526 28.1639 18.526C29.0644 18.526 29.7919 17.7985 29.7919 16.898Z"
						fill="black"
					/>
				</g>
				<defs>
					<filter
						id="filter0_d_4669_272"
						x="0.0538921"
						y="0.40097"
						width="39.9401"
						height="39.9401"
						filterUnits="userSpaceOnUse"
						colorInterpolationFilters="sRGB">
						<feFlood floodOpacity="0" result="BackgroundImageFix" />
						<feColorMatrix
							in="SourceAlpha"
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha"
						/>
						<feOffset dy="3.47305" />
						<feGaussianBlur stdDeviation="3.47305" />
						<feComposite in2="hardAlpha" operator="out" />
						<feColorMatrix
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
						/>
						<feBlend
							mode="normal"
							in2="BackgroundImageFix"
							result="effect1_dropShadow_4669_272"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect1_dropShadow_4669_272"
							result="shape"
						/>
					</filter>
				</defs>
			</svg>
		),
		graphTitle: "Gait Speed",
		graphTitleDesc: "(m/s)",
		graphNormValue: 0,
		isgraphNorm: true,
		graphActualValue: [score?.gaitSpeed],
		graphActualValueLabel: [`${score?.gaitSpeed}`],
		graphRange: [0.5, 0.75, 1, 1.5],
		graphRangeLabel: [".50", ".75", "1", "1.50"],
		graphNoLines: [],
		minMax: false,
		graphUnit: "",
		graphAge: convertDOBintoAge(new Date(patientInfo?.dob)),
	};
	let stepsLengthOption = {
		graphName: "StepsLength",
		graphSVG: (
			<svg
				width="25"
				height="36"
				viewBox="0 0 25 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<g filter="url(#filter0_d_4985_5787)">
					<path
						d="M13.8077 5.2093C15.2462 5.2093 16.4231 4.03721 16.4231 2.60465C16.4231 1.17209 15.2462 0 13.8077 0C12.3692 0 11.1923 1.17209 11.1923 2.60465C11.1923 4.03721 12.3692 5.2093 13.8077 5.2093ZM8.96923 9.63721L5.62154 26.4502C5.45154 27.2447 6.07923 28 6.90308 28H7.00769C7.62231 28 8.14538 27.5833 8.28923 26.9842L10.4077 17.5814L13.1538 20.186V26.6977C13.1538 27.414 13.7423 28 14.4615 28C15.1808 28 15.7692 27.414 15.7692 26.6977V19.3526C15.7692 18.6363 15.4815 17.9591 14.9585 17.4642L13.0231 15.6279L13.8077 11.7209C15.2069 13.3358 17.2338 14.4949 19.5092 14.8595C20.2938 14.9767 21 14.3516 21 13.5572C21 12.9191 20.5292 12.3851 19.8885 12.2809C17.9008 11.9553 16.2531 10.7833 15.3769 9.24651L14.0692 7.16279C13.3369 6.00372 11.8723 5.53488 10.6038 6.06884L5.59538 8.17861C4.62769 8.59535 4 9.53302 4 10.5879V13.6744C4 14.3907 4.58846 14.9767 5.30769 14.9767C6.02692 14.9767 6.61538 14.3907 6.61538 13.6744V10.5488L8.96923 9.63721Z"
						fill="#31344E"
					/>
				</g>
				<defs>
					<filter
						id="filter0_d_4985_5787"
						x="0"
						y="0"
						width="25"
						height="36"
						filterUnits="userSpaceOnUse"
						colorInterpolationFilters="sRGB">
						<feFlood floodOpacity="0" result="BackgroundImageFix" />
						<feColorMatrix
							in="SourceAlpha"
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha"
						/>
						<feOffset dy="4" />
						<feGaussianBlur stdDeviation="2" />
						<feComposite in2="hardAlpha" operator="out" />
						<feColorMatrix
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
						/>
						<feBlend
							mode="normal"
							in2="BackgroundImageFix"
							result="effect1_dropShadow_4985_5787"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect1_dropShadow_4985_5787"
							result="shape"
						/>
					</filter>
				</defs>
			</svg>
		),
		graphTitle: "Step Length",
		graphTitleDesc: "",
		graphNormValue: 0,
		isgraphNorm: true,
		graphActualValue: [score?.left.stepLength, score?.right.stepLength],
		graphActualValueLabel: [
			score?.left.stepLength.toString(),
			score?.right.stepLength.toString(),
		],
		graphRange: [20, 40, 60, 80],
		graphRangeLabel: ["20", "40", "60", "80"],
		graphNoLines: ["L", "R"],
		minMax: false,
		graphUnit: "Centimeters",
		graphAge: convertDOBintoAge(new Date(patientInfo?.dob)),
	};
	let numberOfStepsOption = {
		graphName: "NumbersOfSteps",
		graphSVG: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="49"
				height="36"
				viewBox="0 0 49 36"
				fill="none">
				<g filter="url(#filter0_d_4669_308)">
					<path
						d="M8.30103 14.8873C9.80847 17.4983 13.8029 20.9639 13.8029 20.9639L20.6651 19.0374C19.5292 17.0699 19.7243 15.6815 19.9195 14.293C20.1146 12.9045 20.3098 11.516 19.1739 9.54858C17.8392 7.23684 14.1512 2.57544 9.86232 3.77949C5.57347 4.98354 6.02923 10.9525 8.30103 14.8873ZM20.2631 25.2471C22.1555 24.7158 23.015 23.1075 22.1796 21.6606L21.4223 20.349L14.5602 22.2755L15.3174 23.5871C16.1528 25.034 18.3706 25.7784 20.2631 25.2471ZM38.7787 12.428C36.5069 8.49307 30.9046 3.969 26.6157 5.17305C22.3269 6.37709 24.2994 11.5201 25.6341 13.8318C26.77 15.7993 28.2903 16.7061 29.8107 17.613C31.3311 18.5199 32.8515 19.4267 33.9874 21.3942L40.8495 19.4677C40.8495 19.4677 40.2862 15.0389 38.7787 12.428ZM40.4475 25.6774C42.34 25.1462 43.1994 23.5378 42.3641 22.0909L41.6068 20.7793L34.7446 22.7058L35.5019 24.0174C36.3373 25.4643 38.5551 26.2087 40.4475 25.6774Z"
						fill="black"
					/>
				</g>
				<defs>
					<filter
						id="filter0_d_4669_308"
						x="0.423875"
						y="0.494286"
						width="48.4394"
						height="34.6242"
						filterUnits="userSpaceOnUse"
						colorInterpolationFilters="sRGB">
						<feFlood floodOpacity="0" result="BackgroundImageFix" />
						<feColorMatrix
							in="SourceAlpha"
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha"
						/>
						<feOffset dy="3.08982" />
						<feGaussianBlur stdDeviation="3.08982" />
						<feComposite in2="hardAlpha" operator="out" />
						<feColorMatrix
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
						/>
						<feBlend
							mode="normal"
							in2="BackgroundImageFix"
							result="effect1_dropShadow_4669_308"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect1_dropShadow_4669_308"
							result="shape"
						/>
					</filter>
				</defs>
			</svg>
		),
		graphTitle: "Number of Steps",
		graphTitleDesc: "",
		graphNormValue: 0,
		isgraphNorm: false,
		graphActualValue: [score?.numberOfSteps],
		graphActualValueLabel: [`${score?.numberOfSteps}`],
		graphRange: [5, 10, 15, 20],
		graphRangeLabel: ["5", "10", "15", "20"],
		graphNoLines: [],
		minMax: false,
		graphUnit: "",
		graphAge: convertDOBintoAge(new Date(patientInfo?.dob)),
	};
	return (
		<>
			{score &&
				score?.fallRisk != 0 &&
				!isNaN(score?.fallRisk) &&
				patientage > 70 && <CustomBarGraph options={fallRiskOption} />}
			{score && score?.gaitSpeed != 0 && !isNaN(score?.gaitSpeed) && (
				<CustomBarGraph options={gaitSpeedOption} />
			)}
			{/* {score &&
				!isNaN(score?.left.stepLength) &&
				!isNaN(score?.right.stepLength) &&
				score?.left &&
				score?.right &&
				score?.left.stepLength != 0 &&
				score?.right.stepLength != 0 && (
					<CustomBarGraph options={stepsLengthOption} />
				)} */}
			{score && score?.numberOfSteps != 0 && !isNaN(score?.numberOfSteps) && (
				<CustomBarGraph options={numberOfStepsOption} />
			)}
		</>
	);
};

export default Gait_Test;
